// src/screens/mypage/ReservationHistoryScreen.js
// 14차: 목록 탭 제거 → 캘린더에 통합 / 리뷰 탭 제거 → MyReviewsScreen으로 이동 버튼만
// 15차: 예약 카드에 테마 썸네일 이미지 추가 (productService.getProductById로 로드)
// 36차: 예약 변경 기능 추가 (날짜/시간) — changeReservation 트랜잭션 사용
// 38차: ChangeReservationModal — isPastSlot 적용(과거 시간 선택 차단), 슬롯 문구 통일(예약 가능/예약 종료)
// 51차: 색 theme.js 단일화 — COLORS 참조 / 초록·빨강·주황·파랑 통일, 일/토 RED/BLUE
// 72차: 예약 카드에 "💌 이 예약 문의하기" 버튼 추가 — WriteInquiryScreen으로 이동해
//       매장에 이 예약 건에 대한 문의를 남길 수 있음 (storeId 있는 예약만 노출)
// 74차: 화면 자체 커스텀 헤더(뒤로가기+제목) → 공통 AppHeader로 교체 (다른 화면과 톤 통일)
// 77차: 74차 교체 시 제목이 누락돼(AppHeader에 centerElement를 안 넘김) "‹ 뒤로"만 있는
// 빈 헤더로 보이던 것 — "AppHeader 없음" 반복 신고의 실제 원인. 제목 복원.
// 78차 66차: "날짜 변경 진행 시 오류 발생" — 여러 세션에 걸쳐 재현 실패했던 버그의
// 실제 원인 발견. ChangeReservationModal이 달력에서 날짜를 실제로 선택해야만 렌더되는
// "시간 선택" 섹션에서 MenuPointsIcon을 쓰는데 이 파일 상단에 import가 아예 없었음
// (ReferenceError → 최상위 ErrorBoundary가 화면 전체를 "일시적 오류" 화면으로 덮음).
// 모달을 열기만 하고 날짜를 안 골라보면 안 걸려서 재현이 어려웠던 것 — 라이브로 날짜를
// 직접 선택해보고서야 확진.
// 78차: QR코드 기능 삭제(사용 안 할 예정) — QRModal.js 자체를 삭제하고 이 화면의 연동
// (import, qrTarget 상태, "📱 QR코드 보기" 버튼, onQR prop 체인)을 전부 제거.
// 78차: 예약취소/날짜변경/리뷰작성/다시예약/문의하기 버튼을 공용 Danger/Secondary/Text
// 버튼 컴포넌트로 교체 — 77차 버튼 시스템 도입 때 이 화면이 대상에서 빠져 있었음.

// 78차 32차: 모달 닫기(✕) 버튼에 accessibilityLabel 추가(접근성 라벨 전수 점검)
// 80차: 체험형 공연(정원제) 예약 취소를 cancelShowReservation(CF) 경유로 분기, 날짜
//       변경 버튼은 v1 미지원이라 숨김(취소 후 재예약으로 대체).
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, TouchableOpacity, StyleSheet,
  ActivityIndicator, ScrollView, Modal,
} from 'react-native';
// 78차 37차: 썸네일 캐싱 없이 매번 재다운로드되던 것 — expo-image로 교체(디스크 캐시 자동)
import { Image } from 'expo-image';
import * as Sentry from '@sentry/react-native';
import AppHeader from '../../components/common/AppHeader';
import { SecondaryButton, DangerButton } from '../../components/common/Buttons';
import { Calendar, LocaleConfig } from 'react-native-calendars';
import { getMyReservations, cancelReservation, cancelShowReservation, changeReservation, getBookedTimes } from '../../services/reservationService';
import { markNotificationsReadByType } from '../../services/recruitService';
import { getProductById, normalizeProduct } from '../../services/productService';
import LoadingOverlay from '../../components/common/LoadingOverlay';
import { MenuStoreIcon, MenuReservationIcon, MenuEscapeIcon, PeopleIcon, PaymentIcon, RewardIcon, MenuPointsIcon, IconLabel, CancelIcon, EscapeRecordSuccessIcon, EscapeRecordFailIcon, EmptyReservationsIcon, MenuReviewIcon } from '../../components/common/Icons';
import { LogoMark } from '../../components/common/AppHeader';
import { useAuth } from '../../contexts/AuthContext';
import { COLORS } from '../../constants/theme';

// 36차: 달력 로케일
LocaleConfig.locales['ko'] = {
  monthNames: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
  monthNamesShort: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
  dayNames: ['일요일','월요일','화요일','수요일','목요일','금요일','토요일'],
  dayNamesShort: ['일','월','화','수','목','금','토'],
  today: '오늘',
};
LocaleConfig.defaultLocale = 'ko';

const GOLD = COLORS.gold, BG = COLORS.bg, SURFACE = COLORS.surface, SURFACE2 = COLORS.surface2;
const BORDER = COLORS.border, TEXT = COLORS.text;
const TEXT_SEC = COLORS.textSec, TEXT_MUTED = COLORS.textMuted;
const RED = COLORS.red, GREEN = COLORS.green, ORANGE = COLORS.orange, BLUE = COLORS.blue;
const ON_GOLD = COLORS.onGold;

// 38차: 과거 시간 여부 판별 (날짜+시간 기준) — ChangeReservationModal 내 사용
const isPastSlotInModal = (dateStr, timeStr) => {
  if (!dateStr || !timeStr) return false;
  const [year, month, day] = dateStr.split('-').map(Number);
  const [h, m] = timeStr.split(':').map(Number);
  return new Date(year, month - 1, day, h, m, 0, 0) <= new Date();
};

// 36차: 예약 변경 모달
// 38차: isPastSlot 적용 — 과거 시간 선택 차단 / 슬롯 문구 '예약 가능' / '예약 종료' 로 통일
function ChangeReservationModal({ visible, item, onClose, onChanged }) {
  // 78차: UTC 기준(toISOString)이던 것을 이 파일의 기존 getLocalToday()로 교체(일관성 + 버그 수정)
  const todayStr = getLocalToday();
  const [selDate,    setSelDate]    = useState('');
  const [selTime,    setSelTime]    = useState('');
  const [bookedSet,  setBookedSet]  = useState(new Set());
  const [loadSlots,  setLoadSlots]  = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [availTimes, setAvailTimes] = useState([]);

  useEffect(() => {
    if (!visible) { setSelDate(''); setSelTime(''); setBookedSet(new Set()); setAvailTimes([]); }
    else if (item?.productId) {
      getProductById(item.productId)
        .then(p => {
          if (!p) return;
          const stored = p.availableTimes || [];
          if (stored.length > 0) { setAvailTimes(stored); return; }
          const times = [];
          if (p.startTime && p.endTime) {
            // 79차: [버그 수정] interval이 0 이하(prepMinutes 음수 허용 정책으로 실제
            // 가능)면 이 for문이 무한루프(→ V8 배열 크기 폭주로 프로세스 강제종료, 직접
            // 재현 확인)에 빠지고, 자정을 넘는 영업시간(예: 22:00~02:00)은 반대로 시간대가
            // 0개가 되던 버그 — 이 세션에서 ThemeDetailScreen.js/BookingDetailScreen.js의
            // 동일한 폴백 로직에 이미 적용한 것과 동일한 가드(interval 최소 1, 자정 넘김
            // 지원)를 이 화면(예약 날짜 변경 모달)만 놓치고 있었음.
            const interval = Math.max(1, Number(p.intervalMinutes) || 1);
            const [sh, sm] = p.startTime.split(':').map(Number);
            const [eh, em] = p.endTime.split(':').map(Number);
            const startMin = sh * 60 + sm;
            let endMin = eh * 60 + em;
            if (endMin <= startMin) endMin += 24 * 60;
            for (let t = startMin; t < endMin; t += interval) {
              const wrapped = t % (24 * 60);
              times.push(`${String(Math.floor(wrapped/60)).padStart(2,'0')}:${String(wrapped%60).padStart(2,'0')}`);
            }
          }
          setAvailTimes(times);
        })
        .catch(() => {});
    }
  }, [visible, item?.productId]);

  const handleDateSelect = async (day) => {
    setSelDate(day.dateString);
    setSelTime('');
    if (!item?.productId) return;
    setLoadSlots(true);
    try {
      const booked = await getBookedTimes(item.productId, day.dateString);
      setBookedSet(booked);
    } catch { setBookedSet(new Set()); }
    finally { setLoadSlots(false); }
  };

  const handleSubmit = async () => {
    if (!selDate || !selTime) return;
    // 38차: 제출 직전 과거 시간 재검증
    if (isPastSlotInModal(selDate, selTime)) {
      showAlert('선택 불가', '이미 지난 시간대는 선택할 수 없어요.');
      setSelTime('');
      return;
    }
    setSubmitting(true);
    try {
      await changeReservation({ reservationId: item.id, uid: item.uid, newDate: selDate, newTime: selTime });
      onChanged(item.id, selDate, selTime);
      onClose();
    } catch (e) {
      if (e.message === 'SLOT_TAKEN') {
        showAlert('예약 종료', '방금 다른 분이 해당 시간을 예약했어요.\n다른 시간을 선택해주세요.');
        const booked = await getBookedTimes(item.productId, selDate).catch(() => new Set());
        setBookedSet(booked);
        setSelTime('');
      } else if (e.message === 'RECRUIT_RESERVATION') {
        showAlert('변경 불가', '모집을 통한 예약은 변경할 수 없어요.');
        onClose();
      } else {
        // 78차 35차: "날짜 변경 진행 시 에러 발생" 신고 — 재현은 못 했으나 원인 파악을
        // 위해 Sentry 기록 + 에러 코드를 화면에도 노출(74차 QuickBookSheet와 동일 패턴).
        // 유력 후보: 매장관리자가 수동입력한 예약(isManual)의 reservationSlots 잠금
        // 문서는 uid가 매장관리자 본인으로 저장돼 있어(78차 30차), 고객이 그 예약을
        // 변경하려 하면 기존 슬롯 delete 권한이 없어 트랜잭션 전체가 permission-denied로
        // 실패할 수 있음 — 다음 발생 시 e.code로 확진 가능.
        Sentry.captureException(e, { tags: { flow: 'change_reservation' }, extra: { reservationId: item?.id } });
        showAlert('오류', `예약 변경 중 오류가 발생했어요. 다시 시도해주세요.${e.code ? `\n(${e.code})` : ''}`);
      }
    } finally { setSubmitting(false); }
  };

  const calTheme = {
    backgroundColor: SURFACE2, calendarBackground: SURFACE2,
    textSectionTitleColor: TEXT_MUTED, todayTextColor: GOLD,
    dayTextColor: TEXT, textDisabledColor: '#333',
    selectedDayBackgroundColor: GOLD, selectedDayTextColor: ON_GOLD,
    arrowColor: GOLD, monthTextColor: TEXT,
    textDayFontWeight: '600', textMonthFontWeight: '800',
  };

  if (!item) return null;

  return (
    <Modal visible={visible} animationType="slide" transparent onRequestClose={onClose}>
      <View style={cm.overlay}>
        <View style={cm.sheet}>
          <View style={cm.header}>
            <IconLabel Icon={MenuReservationIcon} size={15} color={TEXT} textStyle={cm.title}>예약 변경</IconLabel>
            <TouchableOpacity onPress={onClose} accessibilityLabel="닫기"><CancelIcon size={16} color={cm.close.color || TEXT_MUTED} /></TouchableOpacity>
          </View>
          <Text style={cm.sub}>현재: {item.date} {item.time}</Text>

          <ScrollView showsVerticalScrollIndicator={false} style={{ maxHeight: 460 }}>
            <Calendar
              minDate={todayStr}
              onDayPress={handleDateSelect}
              markedDates={selDate ? { [selDate]: { selected: true, selectedColor: GOLD } } : {}}
              theme={calTheme}
            />

            {selDate && (
              <View style={cm.timeSection}>
                <IconLabel Icon={MenuPointsIcon} size={13} color={TEXT} textStyle={cm.timeSectionTitle}>시간 선택</IconLabel>
                {loadSlots
                  ? <ActivityIndicator color={GOLD} style={{ marginVertical: 12 }} />
                  : availTimes.length === 0
                    ? <Text style={cm.noTime}>등록된 시간대가 없습니다.</Text>
                    : (
                      <>
                        <View style={cm.timeGrid}>
                          {availTimes.map(t => {
                            // 38차: 예약됨(본인 현재 슬롯 제외) 또는 과거 시간이면 비활성
                            const isBooked = bookedSet.has(t) && t !== item.time;
                            const isPast   = isPastSlotInModal(selDate, t);
                            const disabled = isBooked || isPast;
                            const isActive = selTime === t;
                            return (
                              <TouchableOpacity
                                key={t}
                                style={[
                                  cm.timeBtn,
                                  isActive  && cm.timeBtnActive,
                                  disabled  && cm.timeBtnBooked,
                                ]}
                                onPress={() => !disabled && setSelTime(t)}
                                disabled={disabled}>
                                <Text style={[
                                  cm.timeBtnText,
                                  isActive  && cm.timeBtnTextActive,
                                  disabled  && cm.timeBtnTextBooked,
                                ]}>{t}</Text>
                                {disabled
                                  ? <Text style={cm.slotLabelUnavail}>예약 종료</Text>
                                  : <Text style={[cm.slotLabelAvail, isActive && cm.slotLabelActive]}>예약 가능</Text>
                                }
                              </TouchableOpacity>
                            );
                          })}
                        </View>
                        <View style={cm.legend}>
                          <Text style={cm.legendText}>🟢 예약 가능</Text>
                          <Text style={cm.legendText}>🔴 예약 종료</Text>
                        </View>
                      </>
                    )
                }
              </View>
            )}
          </ScrollView>

          <TouchableOpacity
            style={[cm.confirmBtn, (!selDate || !selTime || submitting) && { opacity: 0.4 }]}
            onPress={handleSubmit}
            disabled={!selDate || !selTime || submitting}>
            {submitting
              ? <ActivityIndicator color={ON_GOLD} />
              : <Text style={cm.confirmBtnText}>
                  {selDate && selTime ? `${selDate} ${selTime}로 변경` : '날짜와 시간을 선택하세요'}
                </Text>
            }
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
}

const cm = StyleSheet.create({
  overlay:    { flex:1, backgroundColor:'rgba(0,0,0,0.7)', justifyContent:'flex-end' },
  sheet:      { backgroundColor:SURFACE, borderTopLeftRadius:20, borderTopRightRadius:20,
                padding:20, paddingBottom:36 },
  header:     { flexDirection:'row', justifyContent:'space-between', alignItems:'center', marginBottom:6 },
  title:      { color:TEXT, fontSize:16, fontWeight:'800' },
  close:      { color:TEXT_MUTED, fontSize:20, fontWeight:'300' },
  sub:        { color:TEXT_SEC, fontSize:12, marginBottom:14 },
  timeSection:{ marginTop:16 },
  timeSectionTitle: { color:TEXT, fontSize:14, fontWeight:'700', marginBottom:10 },
  noTime:     { color:TEXT_MUTED, fontSize:13, textAlign:'center', paddingVertical:12 },
  timeGrid:   { flexDirection:'row', flexWrap:'wrap', gap:8 },
  timeBtn:    { width:'31%', paddingVertical:10, borderRadius:10, backgroundColor:SURFACE2,
                borderWidth:1, borderColor:BORDER, alignItems:'center' },
  timeBtnActive:      { backgroundColor:GOLD+'20', borderColor:GOLD },
  timeBtnBooked:      { backgroundColor:RED+'0F', borderColor:RED+'33', opacity:0.7 },
  timeBtnText:        { color:TEXT_MUTED, fontSize:13, fontWeight:'600' },
  timeBtnTextActive:  { color:GOLD, fontWeight:'800' },
  timeBtnTextBooked:  { color:RED+'99', textDecorationLine:'line-through' },
  // 38차: 슬롯 문구 통일 (예약하기 탭과 동일)
  slotLabelUnavail: { fontSize:9, color:RED, fontWeight:'800', marginTop:2 },
  slotLabelAvail:   { fontSize:9, color:GREEN, fontWeight:'800', marginTop:2 },
  slotLabelActive:  { color:GOLD },
  legend:     { flexDirection:'row', gap:16, marginTop:10, paddingTop:4 },
  legendText: { color:TEXT_MUTED, fontSize:11 },
  confirmBtn: { backgroundColor:GOLD, borderRadius:12, height:52,
                justifyContent:'center', alignItems:'center', marginTop:18 },
  confirmBtnText: { color:ON_GOLD, fontWeight:'800', fontSize:15 },
});

const getLocalToday = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
};
// 15차: 모듈 로드 시점 고정 제거 → 렌더마다 재계산 (자정 넘어도 정확)
// ReservationCard / reviewableCount 계산 시 getLocalToday() 직접 호출

const isCancelled = (r) => r.cancelled === true;

// 날짜+시간 기준 과거 여부 (슬롯 단위)
const isPastSlot = (dateStr, timeStr) => {
  if (!dateStr) return false;
  const today = getLocalToday();
  if (dateStr < today) return true;
  if (dateStr > today) return false;
  // 오늘인 경우 시간 비교
  if (!timeStr) return false;
  const [h, m] = timeStr.split(':').map(Number);
  const now = new Date();
  return now.getHours() * 60 + now.getMinutes() > h * 60 + m;
};
const isPending   = (r) => r.paymentStatus === 'pending' && !isCancelled(r);

const getStatus = (r) => {
  const today = getLocalToday();
  if (isCancelled(r))            return { label: '취소됨',        color: RED        };
  if (isPending(r))              return { label: '접수 확인 중', Icon: MenuReservationIcon, color: ORANGE     };
  if (r.success === true)        return { label: '탈출 성공',   Icon: EscapeRecordSuccessIcon, color: GREEN      };
  if (r.success === false)       return { label: '탈출 실패',   Icon: EscapeRecordFailIcon, color: ORANGE     };
  if (r.reviewed)                return { label: '방문완료',       color: TEXT_MUTED };
  if (r.date && r.date < today)  return { label: '방문완료',       color: TEXT_MUTED };
  return { label: '예약확정', color: GOLD };
};

// ── 썸네일 캐시 + 비동기 로드 컴포넌트 ──────────────────────────────────────
const thumbCache = {};

// 80차 후속: [버그 수정] viewer 없이 getProductById를 호출하고 있어서, 데모 매장
// (isDemo:true, visibleToUid 지정)의 테마는 항상 null을 반환해 썸네일이 안 보였음
// (형식과 무관 — 데모 매장 예약 전체에 해당하는 사각지대였음, 체험형 스크린샷으로 발견).
async function fetchThumb(productId, viewer) {
  if (!productId) return null;
  if (thumbCache[productId] !== undefined) return thumbCache[productId];
  try {
    const p = await getProductById(productId, viewer);
    const url = p ? normalizeProduct(p).thumbnailUrl : null;
    thumbCache[productId] = url || null;
  } catch {
    thumbCache[productId] = null;
  }
  return thumbCache[productId];
}

function ThumbImage({ productId, viewer }) {
  const [uri,   setUri]   = useState(null);
  const [tried, setTried] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchThumb(productId, viewer).then(url => {
      if (!cancelled) { setUri(url); setTried(true); }
    });
    return () => { cancelled = true; };
  }, [productId, viewer?.uid]);

  if (!tried) {
    return (
      <View style={thumb.wrap}>
        <ActivityIndicator size="small" color={GOLD} />
      </View>
    );
  }
  if (uri) {
    return <Image source={{ uri }} style={thumb.wrap} />;
  }
  return (
    <View style={[thumb.wrap, thumb.fallback]}>
      <LogoMark size={26} />
    </View>
  );
}

const thumb = StyleSheet.create({
  wrap:     { width: '100%', height: 140, borderRadius: 10, overflow: 'hidden',
              backgroundColor: SURFACE2 },
  fallback: { justifyContent: 'center', alignItems: 'center' },
});

// ── 캘린더 ────────────────────────────────────────────────────────────────────
function CalendarView({ reservations, onCancel, onReview, onRebook, onChange, onInquiry, viewer }) {
  const today = new Date();
  const [year,        setYear]        = useState(today.getFullYear());
  const [month,       setMonth]       = useState(today.getMonth());
  const [selectedDay, setSelectedDay] = useState(null);
  const [showAll,     setShowAll]     = useState(false);

  const MONTH_NAMES = ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'];
  const DAY_NAMES   = ['일','월','화','수','목','금','토'];

  const changeMonth = (delta) => {
    let m = month + delta, y = year;
    if (m < 0)  { m = 11; y--; }
    if (m > 11) { m = 0;  y++; }
    setMonth(m); setYear(y); setSelectedDay(null); setShowAll(false);
  };

  const daysInMonth  = new Date(year, month + 1, 0).getDate();
  const firstDOW     = new Date(year, month, 1).getDay();
  const todayStr     = getLocalToday(); // 78차: UTC(toISOString) → 로컬 기준
  const thisMonthPfx = `${year}-${String(month + 1).padStart(2, '0')}`;

  const reservationMap = useMemo(() => {
    const map = {};
    reservations.forEach(r => {
      if (!r.date || !r.date.startsWith(thisMonthPfx)) return;
      if (!map[r.date]) map[r.date] = [];
      map[r.date].push(r);
    });
    return map;
  }, [reservations, thisMonthPfx]);

  const selectedKey  = selectedDay ? `${thisMonthPfx}-${String(selectedDay).padStart(2,'0')}` : null;
  const selectedList = selectedKey ? (reservationMap[selectedKey] || []) : [];

  const allThisMonth = useMemo(() => {
    const all = [];
    Object.entries(reservationMap).forEach(([, list]) => list.forEach(r => all.push(r)));
    return all.sort((a, b) => (a.date || '').localeCompare(b.date || ''));
  }, [reservationMap]);

  const cells = [];
  for (let i = 0; i < firstDOW; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const displayList = showAll ? allThisMonth : (selectedDay ? selectedList : null);

  const isPastDate = (d) =>
    `${thisMonthPfx}-${String(d).padStart(2,'0')}` < todayStr;

  return (
    <View>
      {/* 78차 66차: 웹(특히 데스크톱)에서 이 그리드가 % 기반 폭이라 부모(75% 폭 제한된
          본문)를 그대로 채우며 칸 하나하나가 지나치게 커 보이던 문제 — 달력 부분만
          모바일 폭 정도로 상한을 두고 가운데 정렬(네이티브는 이미 화면이 좁아 거의
          영향 없음). */}
      <View style={{ maxWidth: 420, alignSelf: 'center', width: '100%' }}>
        {/* 헤더 */}
        <View style={cal.header}>
          <TouchableOpacity onPress={() => changeMonth(-1)} style={cal.arrow}>
            <Text style={cal.arrowTxt}>‹</Text>
          </TouchableOpacity>
          <Text style={cal.title}>{year}년 {MONTH_NAMES[month]}</Text>
          <TouchableOpacity onPress={() => changeMonth(1)} style={cal.arrow}>
            <Text style={cal.arrowTxt}>›</Text>
          </TouchableOpacity>
        </View>

        {/* 요일 */}
        <View style={cal.weekRow}>
          {DAY_NAMES.map((d, i) => (
            <Text key={d} style={[cal.weekDay, i===0&&{color:RED}, i===6&&{color:BLUE}]}>{d}</Text>
          ))}
        </View>

        {/* 날짜 그리드 */}
        <View style={cal.grid}>
          {cells.map((d, idx) => {
            if (d === null) return <View key={`e${idx}`} style={cal.cell} />;
            const dateKey      = `${thisMonthPfx}-${String(d).padStart(2,'0')}`;
          const resList      = reservationMap[dateKey] || [];
          const isToday      = dateKey === todayStr;
          const isSel        = d === selectedDay;
          const isPast       = isPastDate(d);
          const hasActive    = resList.some(r => !isCancelled(r));
          const hasCancelled = resList.some(r => isCancelled(r));
          return (
            <TouchableOpacity
              key={d}
              style={[cal.cell, isSel && cal.cellSel]}
              onPress={() => { setSelectedDay(isSel ? null : d); setShowAll(false); }}>
              <View style={[cal.cellInner, isPast && { opacity: 0.35 }]}>
                <Text style={[
                  cal.cellTxt,
                  isSel && cal.cellTxtSel,
                  isToday && !isSel && { color: GOLD, fontWeight: '800' },
                  idx % 7 === 0 && !isSel && { color: RED },
                  idx % 7 === 6 && !isSel && { color: BLUE },
                ]}>{d}</Text>
                <View style={cal.dotRow}>
                  {hasActive    && <View style={[cal.dot, { backgroundColor: GOLD }]} />}
                  {hasCancelled && <View style={[cal.dot, { backgroundColor: RED  }]} />}
                  {!hasActive && !hasCancelled && <View style={[cal.dot, { backgroundColor:'transparent' }]} />}
                </View>
              </View>
            </TouchableOpacity>
          );
        })}
        </View>
      </View>

      {/* 전체 보기 버튼 */}
      <TouchableOpacity
        style={[cal.allBtn, showAll && cal.allBtnOn]}
        onPress={() => { setShowAll(p => !p); setSelectedDay(null); }}>
        {showAll
          ? <Text style={[cal.allBtnTxt, cal.allBtnTxtOn]}>▲ 전체 목록 닫기</Text>
          : <IconLabel Icon={MenuReservationIcon} size={12} color={cal.allBtnTxt.color || TEXT_MUTED} textStyle={cal.allBtnTxt}>{`이번 달 전체 보기 (${allThisMonth.length}건)`}</IconLabel>}
      </TouchableOpacity>

      {/* 예약 목록 */}
      <View style={cal.selectedSection}>
        {displayList === null ? (
          <View style={{ alignItems:'center', paddingVertical:20 }}>
            <Text style={{ fontSize:28, marginBottom:8 }}>👆</Text>
            <Text style={{ color:TEXT_MUTED, fontSize:13 }}>날짜를 선택하거나 전체 보기를 눌러보세요</Text>
          </View>
        ) : displayList.length === 0 ? (
          <View style={{ alignItems:'center', paddingVertical:20 }}>
            <View style={{ marginBottom:8 }}><EmptyReservationsIcon size={28} /></View>
            <Text style={{ color:TEXT_MUTED, fontSize:13 }}>이 날 예약이 없습니다.</Text>
          </View>
        ) : (
          <>
            <Text style={cal.selectedTitle}>
              {showAll ? `${MONTH_NAMES[month]} 전체` : `${month+1}월 ${selectedDay}일`} · {displayList.length}건
            </Text>
            {displayList.map(r => (
              <ReservationCard
                key={r.id}
                item={r}
                onCancel={onCancel}
                onReview={onReview}
                onRebook={onRebook}
                onChange={onChange}
                onInquiry={onInquiry}
                viewer={viewer}
              />
            ))}
          </>
        )}
      </View>
    </View>
  );
}

// ── 예약 카드 ─────────────────────────────────────────────────────────────────
function ReservationCard({ item, onCancel, onReview, onRebook, onChange, onInquiry, viewer }) {
  const today     = getLocalToday();
  const status    = getStatus(item);
  const isPast    = item.date && item.date < today;
  // 지난 날짜 or 지난 시간대 슬롯은 카드 전체를 흐리게
  const isDimmed  = isPastSlot(item.date, item.time) && !isCancelled(item);
  // 78차 67차: isPast(달력일 기준)만 보고 있어서, 매장이 결과를 이미 입력한 "오늘" 예약은
  // 다음날까지 리뷰 작성 버튼이 안 뜨던 버그 — 결과 입력(success!=null) 시 즉시 허용.
  const canReview  = (isPast || item.success != null) && !isCancelled(item) && !item.reviewed && !isPending(item);
  // 80차 후속: 모집 일괄예약(체험형/방탈출 둘 다)은 참가자 전원이 형제 예약과 정원
  // (bookedCount) 또는 슬롯 잠금 하나를 공유해서, 개인이 혼자 취소하면 그룹 전체가
  // 잘못 풀린다 — 서버(cancelShowReservationCF/cancelReservation)도 이 조합의
  // 셀프취소를 거부하므로, 버튼 자체를 숨겨 헛된 시도/에러를 방지.
  const isRecruitGroup = item.paymentType === 'recruit';
  const canCancel  = !isCancelled(item) && !isPast && !isPending(item) && !isRecruitGroup;
  // 80차 후속: [버그 수정, fork로 발견] 그룹예약 참가자 문서의 people은 본인 1인 몫이
  // 아니라 그룹 전체 인원(recruit.totalSlots)이라, 그대로 "다시 예약"의 initialPeople로
  // 넘기면 이제 개인 재예약인데 엉뚱한 인원수(예: 4인)가 자동선택됨 — canChange와 동일하게
  // 그룹예약은 버튼 자체를 숨김(재예약은 개인 단위 행동이라 그룹 맥락과 안 맞음).
  const canRebook  = (isPast || isCancelled(item)) && !isRecruitGroup;
  // 36차: 변경 가능 조건 — 미래 예약 + 미취소 + 미결제대기 + 모집예약 제외
  // 80차: 체험형 공연(정원제)은 날짜/시간 변경 v1 미지원 — 취소 후 재예약으로 대체
  const canChange  = !isCancelled(item) && !isPast && !isPending(item) && item.paymentType !== 'recruit' && item.bookingFormat !== 'show';

  return (
    <View style={[s.card, isDimmed && { opacity: 0.55 }]}>
      {/* 썸네일 이미지 */}
      <ThumbImage productId={item.productId} viewer={viewer} />

      <View style={s.cardBody}>
        <View style={s.cardTop}>
          <View style={[s.badge, { backgroundColor: status.color+'22', borderColor: status.color+'55' }]}>
            {status.Icon
              ? <IconLabel Icon={status.Icon} size={11} color={status.color} textStyle={[s.badgeText, { color: status.color }]}>{status.label}</IconLabel>
              : <Text style={[s.badgeText, { color: status.color }]}>{status.label}</Text>}
          </View>
          <IconLabel Icon={MenuReservationIcon} size={11} color={TEXT_MUTED} textStyle={s.date}>{item.date}{item.time ? ` · ${item.time}` : ''}</IconLabel>
        </View>

        <IconLabel Icon={MenuEscapeIcon} size={13} color={TEXT} textStyle={s.themeName} numberOfLines={1}>
          {item.themeName || item.productName || '테마 정보 없음'}
        </IconLabel>

        {isPending(item) && (
          <View style={s.pendingBox}>
            <IconLabel Icon={MenuReservationIcon} size={12} color={s.pendingBoxText.color || TEXT_MUTED} textStyle={s.pendingBoxText}>외부에서 접수된 예약입니다. 매장에 문의해주세요.</IconLabel>
          </View>
        )}

        {/* 80차 후속: 취소/변경 버튼이 안 보이는 이유를 안내 */}
        {!isCancelled(item) && !isPast && !isPending(item) && isRecruitGroup && (
          <View style={s.pendingBox}>
            <Text style={s.pendingBoxText}>그룹 예약은 모집 작성자 또는 매장에 문의해주세요.</Text>
          </View>
        )}
        {canCancel && !canChange && item.bookingFormat === 'show' && (
          <Text style={{ color: TEXT_MUTED, fontSize: 11, marginTop: 4 }}>체험형 예약은 취소 후 재예약해주세요.</Text>
        )}

        {item.branchName && <IconLabel Icon={MenuStoreIcon} size={11} color={TEXT_MUTED} textStyle={s.branchName}>{item.branchName}</IconLabel>}

        <View style={s.detailRow}>
          {!!item.people && <DetailChip Icon={PeopleIcon} label={String(item.people)} />}
          {!!item.price  && <DetailChip Icon={PaymentIcon} label={`${Number(item.price).toLocaleString()}원`} />}
          {(item.usedPoints > 0) && <DetailChip Icon={RewardIcon} label={`-${Number(item.usedPoints).toLocaleString()}P`} color={GOLD} />}
        </View>

        {item.success === true && item.escapeTime && (
          <Text style={s.escapeTime}>⏱️ 탈출 시간: {item.escapeTime}</Text>
        )}

        {/* 78차 38차: 세 버튼(취소/날짜변경/리뷰작성)이 flex:1로 3등분된 좁은 폭에
            이모지+라벨이 다 안 들어가 두 줄로 줄바꿈되던 것 — 이모지 제거 + 폰트 축소로
            한 줄에 들어가게 함.
            78차 66차: "이 예약 문의하기"가 별도 줄(전체 폭)로 떨어져 있어 취소/변경과
            안 나란히 보인다는 신고 — 같은 줄에 넣고 패딩/폰트를 더 줄여 4개까지도
            한 줄에 들어가게 함(실제로는 canReview가 isPast일 때만 true라 canCancel/
            canChange와 동시에 뜨지 않아 최대 3개: [취소,변경,문의] 또는 [리뷰,문의]). */}
        {(canCancel || canChange || canReview || !!item.storeId) && (
          <View style={s.btnRow}>
            {canCancel && (
              <DangerButton label="예약 취소" onPress={() => onCancel(item.id)} style={s.flexBtn} textStyle={s.actionBtnTxt} />
            )}
            {canChange && (
              <SecondaryButton label="날짜 변경" onPress={() => onChange(item)} style={s.flexBtn} textStyle={s.actionBtnTxt} />
            )}
            {canReview && (
              <SecondaryButton label="리뷰 작성" onPress={() => onReview(item)} style={s.flexBtn} textStyle={s.actionBtnTxt} />
            )}
            {!!item.storeId && (
              <SecondaryButton label="문의하기" onPress={() => onInquiry(item)} style={s.flexBtn} textStyle={s.actionBtnTxt} />
            )}
          </View>
        )}

        {canRebook && (
          <SecondaryButton label="🔄 같은 테마 다시 예약" onPress={() => onRebook(item)} style={s.rebookBtnWrap} />
        )}
      </View>
    </View>
  );
}

function DetailChip({ icon, Icon, label, color }) {
  return (
    <View style={[s.detailChip, { flexDirection: 'row', alignItems: 'center', gap: 4 }]}>
      {Icon ? <Icon size={11} color={color || TEXT_MUTED} /> : null}
      <Text style={[s.detailChipText, color && { color }]}>{Icon ? '' : `${icon} `}{label}</Text>
    </View>
  );
}

// ── 메인 ─────────────────────────────────────────────────────────────────────
export default function ReservationHistoryScreen({ navigation }) {
  const { user } = useAuth();
  const [list,         setList]         = useState([]);
  const [loading,      setLoading]      = useState(true);
  const [changeTarget, setChangeTarget] = useState(null); // 36차: 변경 대상

  useEffect(() => {
    getMyReservations(user.uid)
      .then(setList)
      .catch(() => showAlert('오류', '예약 내역을 불러오지 못했어요. 다시 시도해주세요.'))
      .finally(() => setLoading(false));
    // 79차: 마이탭 "예약 내역" 뱃지(reservation_reminder/store_closed)가 이 화면을 거쳐도
    // 안 사라지던 버그 — InquiriesScreen/MyInquiriesScreen(78차68차)과 동일하게, 이 화면
    // 자체는 알림 목록(NotificationsScreen)을 거치지 않고 바로 진입 가능해서 알림 문서가
    // read:false로 계속 남아있었음. 진입 시점에 해당 타입을 일괄 읽음 처리.
    markNotificationsReadByType(user.uid, ['reservation_reminder', 'store_closed']).catch(() => {});
  }, [user.uid]);

  // 78차 52차: 앱에서 취소해도 매장 자체 예약 시스템(외부 URL)에는 아무 것도 전달되지
  // 않는다 — 매장에게는 이미 onReservationCancelled(functions/index.js)가 알림을 보내
  // 지만, 고객 본인에게도 "외부 사이트에서 별도로 취소해야 한다"는 걸 명확히 안내.
  // 78차 66차: (1) 예약 완료 화면에선 "예약 취소는 앱에서도 가능해요"라고만 해놓고
  // 정작 취소 시점엔 "매장 사이트에서도 꼭 취소하라"는 게 처음 듣는 말처럼 느껴진다는
  // 신고 — 예약 완료 화면 문구를 여기와 같은 내용으로 맞춤(ThemeDetailScreen.js/
  // BookingDetailScreen.js의 noticeBox 참고). (2) 문구 자체도 너무 길어 가독성이
  // 떨어진다는 신고 — 짧게 축약.
  const handleCancel = async (id) => {
    const target = list.find(r => r.id === id);
    const product = target?.productId ? await getProductById(target.productId).catch(() => null) : null;
    const isExternal = !!product?.reservationUrl;
    const pointMsg = target?.usedPoints > 0
      ? `\n사용한 포인트 ${Number(target.usedPoints).toLocaleString()}P가 환불돼요.` : '';
    const externalNote = isExternal
      ? '\n\n⚠️ 매장 사이트 예약은 자동 연동되지 않아요. 그쪽에서도 취소해주세요.'
      : '';
    showAlert('예약 취소', `정말 취소하시겠어요?${pointMsg}\n\n취소 후에는 되돌릴 수 없습니다.${externalNote}`, [
      { text: '아니오', style: 'cancel' },
      { text: '취소하기', style: 'destructive', onPress: async () => {
        try {
          // 80차: 체험형 공연(정원제)은 정원 감소가 서버 트랜잭션에서만 이뤄져야 해서 CF 경유
          if (target?.bookingFormat === 'show') {
            await cancelShowReservation(id);
          } else {
            await cancelReservation(id);
          }
          setList(prev => prev.map(r => r.id === id ? { ...r, cancelled: true } : r));
          showAlert('취소 완료', '예약이 취소됐어요.' + (target?.usedPoints > 0
            ? `\n${Number(target.usedPoints).toLocaleString()}P가 환불됐어요.` : '')
            + (isExternal ? '\n\n매장 사이트에서도 취소를 확인해주세요.' : ''));
        } catch {
          showAlert('오류', '취소 처리 중 오류가 발생했어요. 다시 시도해주세요.');
        }
      }},
    ]);
  };

  const handleRebook = (item) => {
    if (!item.productId) { showAlert('알림', '상품 정보를 찾을 수 없어요.'); return; }
    navigation.navigate('BookingDetail', {
      product: {
        id: item.productId, name: item.productName || item.themeName,
        storeName: item.branchName, branchName: item.branchName,
        storeId: item.storeId, paymentType: item.paymentType || 'external',
        // 80차 후속: [버그 수정] 이 값을 안 넘겨서 BookingDetailScreen이 getProductById
        // 재조회가 끝나기 전 짧은 순간 항상 방탈출로 오판(시간 슬롯 조회 소스가 잘못됨) —
        // item(과거 예약)에 이미 저장돼 있는 값을 그대로 넘겨 그 순간 자체를 없앰.
        bookingFormat: item.bookingFormat || 'room',
      },
      // 78차: 지난 예약 인원수를 넘겨 날짜/시간 선택 후 자동으로 인원 버튼이 선택되게 함
      // (날짜/시간은 매번 새로 골라야 해서 그대로 유지 — "완전 원클릭"은 예약 특성상 불가능,
      // 그나마 반복 입력을 줄일 수 있는 인원수만 기본값으로 제공)
      initialPeople: item.people || null,
    });
  };

  const handleGoReview = (item) => {
    navigation.navigate('WriteReview', {
      reservationId: item.id, productId: item.productId,
      productName: item.productName || item.themeName,
      bookingFormat: item.bookingFormat, // 80차 후속: 체험형 공연은 탈출 성공/실패 선택 숨김
    });
  };

  // 72차: 이 예약에 대한 매장 문의 작성
  const handleGoInquiry = (item) => {
    navigation.navigate('WriteInquiry', {
      targetType: 'store',
      storeId: item.storeId,
      context: {
        type: 'reservation',
        reservationId: item.id,
        productName: item.productName || item.themeName,
      },
    });
  };

  // 36차: 예약 변경 완료 콜백
  const handleChanged = (id, newDate, newTime) => {
    setList(prev => prev.map(r =>
      r.id === id ? { ...r, date: newDate, time: newTime, changedAt: new Date().toISOString() } : r
    ));
    showAlert('변경 완료', `예약이 ${newDate} ${newTime}으로 변경됐어요.`);
  };

  // 78차 67차: canReview와 동일한 이유로 success!=null 조건 추가(오늘 결과입력된 예약 포함)
  const reviewableCount = useMemo(() => {
    const today = getLocalToday();
    return list.filter(r => r.date && (r.date < today || r.success != null) && !isCancelled(r) && !r.reviewed && !isPending(r)).length;
  }, [list]);

  if (loading) return <LoadingOverlay />;

  return (
    <View style={s.container}>
      <AppHeader showBack centerElement={<Text style={{ color: COLORS.text, fontSize: 15, fontWeight: '800' }}>예약 내역</Text>} />

      {/* 리뷰 작성 배너 */}
      {reviewableCount > 0 && (
        <TouchableOpacity style={s.reviewBanner} onPress={() => navigation.navigate('MyReviews')}>
          <View style={{ flex:1 }}>
            <IconLabel Icon={MenuReviewIcon} size={13} color={GOLD} textStyle={s.reviewBannerTitle}>작성 가능한 리뷰 {reviewableCount}건</IconLabel>
            <Text style={s.reviewBannerSub}>리뷰 작성 시 100P 적립 · 내 리뷰 화면으로 이동</Text>
          </View>
          <Text style={{ color:GOLD, fontSize:18 }}>›</Text>
        </TouchableOpacity>
      )}

      <ScrollView contentContainerStyle={{ padding:16, paddingBottom:60 }}>
        <CalendarView
          reservations={list}
          onCancel={handleCancel}
          onReview={handleGoReview}
          onRebook={handleRebook}
          onChange={setChangeTarget}
          onInquiry={handleGoInquiry}
          viewer={{ uid: user.uid }}
        />
      </ScrollView>

      <ChangeReservationModal
        visible={!!changeTarget}
        item={changeTarget}
        onClose={() => setChangeTarget(null)}
        onChanged={handleChanged}
      />
    </View>
  );
}

const cal = StyleSheet.create({
  header:          { flexDirection:'row', alignItems:'center', justifyContent:'space-between', marginBottom:12 },
  arrow:           { padding:10 },
  arrowTxt:        { color:GOLD, fontSize:28, fontWeight:'bold' },
  title:           { color:TEXT, fontSize:17, fontWeight:'800' },
  weekRow:         { flexDirection:'row', marginBottom:6, borderBottomWidth:1, borderBottomColor:BORDER, paddingBottom:8 },
  weekDay:         { flex:1, textAlign:'center', color:TEXT_MUTED, fontSize:12, fontWeight:'700' },
  grid:            { flexDirection:'row', flexWrap:'wrap' },
  cell:      { width:'14.28%', aspectRatio:1, alignItems:'center', justifyContent:'center', borderRadius:8 },
  cellSel:   { backgroundColor:GOLD+'25', borderWidth:1, borderColor:GOLD },
  cellInner: { alignItems:'center', justifyContent:'center', width:'100%', height:'100%' },
  cellTxt:   { color:TEXT, fontSize:13, lineHeight:16, textAlign:'center' },
  cellTxtSel:{ color:GOLD, fontWeight:'900' },
  dotRow:    { flexDirection:'row', gap:2, alignItems:'center', justifyContent:'center', height:6, marginTop:1 },
  dot:       { width:4, height:4, borderRadius:2 },
  allBtn:          { marginTop:12, paddingVertical:10, borderRadius:10, borderWidth:1,
                     borderColor:BORDER, alignItems:'center', backgroundColor:SURFACE },
  allBtnOn:        { backgroundColor:GOLD+'15', borderColor:GOLD+'50' },
  allBtnTxt:       { color:TEXT_MUTED, fontSize:12, fontWeight:'600' },
  allBtnTxtOn:     { color:GOLD },
  selectedSection: { marginTop:16, borderTopWidth:1, borderTopColor:BORDER, paddingTop:16, minHeight:80 },
  selectedTitle:   { color:GOLD, fontSize:14, fontWeight:'800', marginBottom:12 },
});

const s = StyleSheet.create({
  container:      { flex:1, backgroundColor:BG },

  reviewBanner:      { flexDirection:'row', alignItems:'center', gap:12,
                       backgroundColor:GOLD+'12', paddingHorizontal:16, paddingVertical:12,
                       borderBottomWidth:1, borderBottomColor:GOLD+'30' },
  reviewBannerTitle: { color:GOLD, fontWeight:'800', fontSize:13 },
  reviewBannerSub:   { color:TEXT_SEC, fontSize:11, marginTop:2 },

  // 카드: 이미지 포함 구조로 변경
  card:           { backgroundColor:SURFACE, borderRadius:14, marginBottom:14,
                    borderWidth:1, borderColor:BORDER, overflow:'hidden' },
  cardBody:       { padding:16 },
  cardTop:        { flexDirection:'row', justifyContent:'space-between', alignItems:'center', marginBottom:10 },
  badge:          { borderRadius:6, paddingHorizontal:8, paddingVertical:3, borderWidth:1 },
  badgeText:      { fontSize:12, fontWeight:'700' },
  date:           { color:TEXT_MUTED, fontSize:12 },
  themeName:      { color:TEXT, fontSize:16, fontWeight:'700', marginBottom:6 },
  branchName:     { color:TEXT_SEC, fontSize:13, marginBottom:10 },
  detailRow:      { flexDirection:'row', flexWrap:'wrap', gap:8, marginBottom:6 },
  detailChip:     { backgroundColor:SURFACE2, borderRadius:6, paddingHorizontal:10,
                    paddingVertical:4, borderWidth:1, borderColor:BORDER },
  detailChipText: { color:TEXT_MUTED, fontSize:12 },
  escapeTime:     { color:GREEN, fontSize:12, fontWeight:'600', marginTop:6 },
  pendingBox:     { backgroundColor:ORANGE+'1A', borderRadius:8, padding:12,
                    borderWidth:1, borderColor:ORANGE+'4D', marginBottom:10 },
  pendingBoxText: { color:ORANGE, fontSize:12, lineHeight:18, fontWeight:'600' },
  btnRow:         { flexDirection:'row', gap:6, marginTop:10 },
  flexBtn:        { flex:1, paddingHorizontal:2 },
  actionBtnTxt:   { fontSize:12 },
  rebookBtnWrap:  { marginTop:8, alignSelf:'stretch' },
});